import React, { memo } from 'react';
import ClimbingPartnersChart from './ClimbingPartnersChart.js';

export const ClimbingPartnersControls = memo(({ 
  numPartners, 
  setNumPartners, 
  selectedStat, 
  setSelectedStat 
}) => {
  const statOptions = [
    { value: 'cpg', label: 'Cumulative Grade' },
    { value: 'attempts', label: 'Total Attempts' },
    { value: 'cleanAscents', label: 'Clean Ascents' },
    { value: 'cleanRoutes', label: 'Clean Routes' }
  ];

  const limitOptions = [
    { value: 5, label: 'Top 5 Partners' },
    { value: 10, label: 'Top 10 Partners' },
    { value: 15, label: 'Top 15 Partners' },
    { value: 20, label: 'Top 20 Partners' },
    { value: 25, label: 'Top 25 Partners' },
    { value: 30, label: 'Top 30 Partners' }
  ];

  return (
    <>
      <select 
        value={numPartners} 
        onChange={(e) => setNumPartners(Number(e.target.value))}
        className="px-3 py-1.5 text-sm rounded border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      >
        {limitOptions.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      <select 
        value={selectedStat}
        onChange={(e) => setSelectedStat(e.target.value)}
        className="px-3 py-1.5 text-sm rounded border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      >
        {statOptions.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </>
  );
});

ClimbingPartnersControls.displayName = 'ClimbingPartnersControls';